import type { Key } from "./en";

export const ar: Record<Key, string> = {
  "action.archive": "أرشفة",
  "action.cancel": "إلغاء",
  "shortcuts.title": "اختصارات الكيبورد",
  "shortcuts.search": "بحث في كل حاجة",
  "shortcuts.send": "إرسال الرسالة",
  "shortcuts.newline": "سطر جديد",
  "shortcuts.slash": "قوالب جاهزة (اكتب / الأول)",
  "shortcuts.accept": "قبول الاقتراح",
  "shortcuts.close": "إغلاق / إلغاء",
  "shortcuts.help": "عرض القايمة دي",
  "export.title": "تنزيل المحادثة دي (Markdown)",
  "export.you": "أنت",
  "quick.label": "متابعات سريعة",
  "quick.shorter": "أقصر",
  "quick.shorter.prompt": "اختصر ده.",
  "quick.simpler": "أبسط",
  "quick.simpler.prompt": "اشرح ده بشكل أبسط.",
  "quick.more": "تفاصيل أكتر",
  "quick.more.prompt": "وسّع أكتر بتفاصيل وأمثلة.",
  "quick.translate": "ترجمة",
  "quick.translate.prompt": "ترجم ده للغة التانية (عربي ↔ إنجليزي).",
  "quick.continue": "كمّل",
  "quick.continue.prompt": "كمّل.",
  "slash.summarize": "تلخيص في نقاط",
  "slash.translate": "ترجمة",
  "slash.explain": "شرح مبسّط",
  "slash.eli5": "اشرحلي كأني طفل",
  "slash.fix": "إيجاد وتصليح غلط",
  "slash.shorten": "اختصار",
  "slash.expand": "توسيع",
  "slash.proofread": "مراجعة لغوية",
  "slash.email": "إيميل احترافي",
  "slash.table": "تحويل لجدول",
  "slash.plan": "خطة خطوة بخطوة",
  "slash.formula": "معادلة إكسل",
  "slash.sql": "استعلام SQL",
  "slash.prompt": "تحسين برومبت",
  "crash.title": "حصلت مشكلة",
  "crash.body":
    "الصفحة دي وقعت، بس محادثاتك في أمان. اعمل تحديث وكمّل، وانسخ التفاصيل لو عايز تبلّغ عنها.",
  "crash.reload": "تحديث",
  "crash.copy": "نسخ التفاصيل",
  "status.title": "حالة النظام",
  "status.hint": "صحة قاعدة البيانات والتخزين لحظة بلحظة (للمالك بس).",
  "status.error": "ماقدرتش أقرا الحالة.",
  "status.db": "قاعدة البيانات",
  "status.kv": "التخزين (KV)",
  "status.providers": "المزودات الشغالة",
  "status.totals": "{users} مستخدم · {conversations} محادثة · {messages} رسالة",
  "status.refresh": "تحديث",
  "focus.exit": "خروج من وضع التركيز",
  "shortcuts.focus": "وضع التركيز (الشات بس)",
  "greet.night": "سهران يا {name}؟",
  "greet.morning": "صباح الخير يا {name}",
  "greet.afternoon": "نهارك سعيد يا {name}",
  "greet.evening": "مساء الخير يا {name}",
  "interface.ambient": "خلفية شفق متحركة",
  "interface.ambientHint":
    "توهّج هادي بيتحرك ببطء ورا التطبيق. مقفول افتراضي، ومبيشتغلش لو تقليل الحركة شغال.",
  "data.title": "بياناتك",
  "data.hint":
    "نزّل كل محادثاتك في ملف واحد، أو هات تاريخك من ChatGPT أو Claude أو تصدير قديم من QN AI (ملف conversations.json).",
  "data.export": "تنزيل كل المحادثات",
  "data.import": "استيراد محادثات",
  "data.exported": "اتنزّل.",
  "data.noChats": "مفيش محادثات في الملف ده.",
  "data.progress": "بستورد… {done} / {total}",
  "data.imported": "اتستوردت {chats} محادثة ({messages} رسالة).",
  "status.dbSize": "حجم قاعدة البيانات",
  "status.cleanup":
    "آخر تنظيف {when}: اتشال {n} سجل قديم (جلسات منتهية، إشعارات قديمة، سجل التدقيق والمهام، فهرس بحث يتيم). بيشتغل يوميًا 03:17 UTC، والمحادثات مبتتلمسش أبدًا.",
  "status.cleanNow": "نضّف دلوقتي",
  "palette.contrast": "تباين عالي",
  "general.extraLarge": "كبير جدًا",
  "sidebar.title": "المحادثات والتنقل",
  "settings.sections": "أقسام الإعدادات",
  "a11y.skip": "تخطَّ للمحتوى",
  "a11y.replyDone": "الرد جاهز.",
  "feedback.good": "رد كويس",
  "feedback.bad": "رد وحش",
  "feedback.why": "إيه الغلط؟",
  "feedback.reason.wrong": "غلط",
  "feedback.reason.too_long": "طويل",
  "feedback.reason.language": "لغة / لهجة",
  "feedback.reason.slow": "بطيء",
  "feedback.reason.unsafe": "مش آمن",
  "feedback.reason.other": "تاني",
  "incidents.title": "الأعطال وجودة الردود",
  "incidents.hint":
    "الأخطاء اللي النظام شافها، متجمعة، ومعاها اقتراح إصلاح. وبتغذّي تعلّمه كمان. والموديلات بتترتب حسب تقييمك.",
  "incidents.none": "مفيش أعطال مفتوحة. 🎉",
  "incidents.resolve": "اتحلّت",
  "incidents.ignore": "تجاهل",
  "incidents.satisfaction": "الرضا حسب الموديل",
  "learning.title": "حلقة التعلّم",
  "learning.hint":
    "كل أسبوع (أو لما تدوس الزرار) النظام بيراجع التقييمات والأعطال ويقترح دروس صغيرة. الدروس اللي توافق عليها بتتضاف لتوجيهات المساعد. وهو مبيغيّرش كود ولا مفاتيح ولا صلاحيات من نفسه.",
  "learning.run": "راجع دلوقتي",
  "learning.accepted": "{n} درس اتقبل",
  "learning.last": "آخر مراجعة {when}",
  "learning.none": "مفيش حاجة مستنية قرارك.",
  "learning.accept": "اقبل الدرس",
  "learning.noted": "تمام",
  "learning.reject": "ارفض",
  "action.copy": "نسخ",
  "msg.listen": "اسمع",
  "msg.stopListening": "إيقاف",
  "action.delete": "حذف",
  "action.edit": "تعديل",
  "action.pin": "تثبيت",
  "action.rename": "إعادة تسمية",
  "action.save": "حفظ",
  "action.unarchive": "إلغاء الأرشفة",
  "action.unpin": "إلغاء التثبيت",

  "auth.tagline": "مساحة الذكاء الاصطناعي الخاصة بك.",
  "auth.firstRun":
    "أهلاً بيك! أنشئ حساب المالك علشان تبدأ. وبعدها تقدر تضيف مزوّدي الذكاء الاصطناعي.",
  "auth.name": "الاسم",
  "auth.email": "البريد الإلكتروني",
  "auth.password": "كلمة المرور",
  "auth.passwordHint": "10 أحرف على الأقل",
  "auth.signIn": "تسجيل الدخول",
  "auth.createAccount": "إنشاء حساب",
  "auth.haveAccount": "عندك حساب؟ سجّل دخولك",
  "auth.noAccount": "معندكش حساب؟ أنشئ واحد",

  "chat.new": "محادثة جديدة",
  "chat.notFound": "المحادثة دي مش موجودة.",
  "composer.placeholder": "اكتب رسالتك لـ AI…",
  "composer.send": "إرسال",
  "composer.stop": "إيقاف",
  "composer.think": "تفكير",
  "composer.disclaimer": "ممكن الذكاء الاصطناعي يغلط. راجع المعلومات المهمة.",
  "empty.title": "أقدر أساعدك في إيه النهارده؟",
  "empty.subtitle": "اسأل في أي حاجة — بالعربي أو بالإنجليزي.",
  "empty.noModelTitle": "اربط أول نموذج",
  "empty.noModelBody":
    "AI بيشتغل مع أي مزوّد: Claude، أو أي واجهة متوافقة مع OpenAI (RunPod وOllama وOpenRouter…) أو Workers AI. ضيف واحد في دقيقة.",
  "empty.addModel": "إضافة نموذج",
  "suggest.1": "اكتب تحديثاً أسبوعياً واضحاً للحالة انطلاقاً من ملاحظاتي",
  "suggest.2": "اشرح كيف يعمل التنبؤ في إدارة القوى العاملة (WFM)",
  "suggest.3": "اكتب رسالة رسمية إلى العميل بخصوص تأخر التسليم",
  "suggest.4": "راجع هذا الكود واقترح تحسينات",

  "msg.edit": "تعديل الرسالة",
  "msg.saveSend": "حفظ وإرسال",
  "msg.regenerate": "إعادة توليد",
  "msg.retryWith": "إعادة المحاولة بنموذج تاني",
  "msg.thinking": "بيفكّر…",
  "msg.thoughts": "التفكير",
  "msg.stopped": "تم الإيقاف.",
  "msg.details": "التفاصيل (الموديل والتوكنز)",
  "msg.empty": "مفيش محتوى.",
  "msg.error": "حصلت مشكلة.",
  "msg.fallbackSummary":
    "جرّب موديل تاني ({n} مرة): الأولانيين كانوا مشغولين أو الحصة خلصت. دوس للتفاصيل.",
  "msg.fallback": "{from} فشل ({reason}). تم التحويل إلى {to}.",

  "model.pick": "اختيار النموذج",
  "model.select": "اختر نموذج",
  "model.auto": "أوتو",
  "model.autoHint":
    "بيختار أنسب موديل لكل رسالة: سريع للأسئلة السريعة، والأقوى للأسئلة الصعبة أو الطويلة، وموديل بيشوف الصور للصور، ووضع Agent لما الطلب محتاج أدوات.",
  "model.autoLast": "آخر اختيار: {model} ({why})",
  "model.why.quick": "سؤال سريع",
  "model.why.normal": "سؤال عادي",
  "model.why.hard": "محتاج تحليل",
  "model.why.code": "كود",
  "model.why.long": "طلب طويل",
  "model.why.tools": "محتاج أدوات",
  "model.why.vision": "فيه صورة",
  "model.tier.top": "الأقوى",
  "model.tier.balanced": "متوازن",
  "model.tier.light": "سريع وخفيف",
  "model.speed": "السرعة",
  "model.none": "لسه مفيش نماذج — ضيف مزوّد من الإعدادات",
  "model.vision": "رؤية",
  "model.thinking": "تفكير",
  "model.tools": "أدوات",

  "sidebar.search": "بحث في المحادثات",
  "sidebar.history": "سجل المحادثات",
  "sidebar.empty": "لسه مفيش محادثات",
  "sidebar.noResults": "مفيش محادثات مطابقة",
  "sidebar.noArchived": "مفيش محادثات مؤرشفة",
  "sidebar.options": "خيارات المحادثة",
  "sidebar.settings": "الإعدادات",
  "sidebar.toggle": "إظهار/إخفاء الشريط الجانبي",
  "sidebar.showArchived": "عرض المؤرشف",
  "sidebar.hideArchived": "إخفاء المؤرشف",
  "sidebar.deleteTitle": "حذف المحادثة دي؟",
  "sidebar.deleteBody": "المحادثة وكل رسايلها هتتحذف نهائيًا.",
  "group.pinned": "المثبّتة",
  "group.today": "النهارده",
  "group.yesterday": "امبارح",
  "group.week": "آخر 7 أيام",
  "group.older": "أقدم",

  "settings.title": "الإعدادات",
  "settings.back": "رجوع للمحادثة",
  "settings.profile": "الملف الشخصي",
  "settings.general": "عام",
  "settings.waterfall": "الـ Waterfall (ترتيب الموديلات)",
  "wf.intro":
    "لما موديل يفشل أو يتأخر، التطبيق بينتقل تلقائي للموديل اللي بعده في القايمة دي. الترتيب بيختلف حسب نوع الطلب: الأسئلة السريعة بتنزل على الموديلات السريعة، والصعبة على الأقوى. وضع أوتو بيختار الموديل الأول لكل رسالة.",
  "wf.kind": "نوع الطلب",
  "wf.kind.fast": "شات سريع",
  "wf.kind.balanced": "عادي",
  "wf.kind.power": "صعب / كود / طويل",
  "wf.kind.agent": "Agent (أدوات)",
  "wf.kind.vision": "فيه صور",
  "wf.kind.fast.hint": "أسئلة قصيرة وتحيات: الموديلات السريعة القادرة الأول.",
  "wf.kind.balanced.hint": "الطلبات اليومية: توازن بين الجودة والسرعة.",
  "wf.kind.power.hint": "تحليل وكود وطلبات طويلة أو صعبة: الأقوى الأول.",
  "wf.kind.agent.hint":
    "ملفات وحسابات متوصلة وتشغيل كود: الموديلات اللي بتدعم الأدوات بس، الأقوى الأول.",
  "wf.kind.vision.hint": "الرسايل اللي فيها صور: الموديلات اللي بتشوف الصور بس.",
  "wf.on": "الـ Waterfall شغّال",
  "wf.off": "الـ Waterfall مقفول (من غير بديل)",
  "wf.auto": "ترتيب تلقائي",
  "wf.manual": "ترتيب يدوي",
  "wf.freeOnly": "مجاني بس",
  "wf.allowPaid": "المدفوع بعد المجاني",
  "wf.adaptive": "بيتعلّم من نسب النجاح الحقيقية",
  "wf.edit": "تغيير الإعدادات",
  "wf.manualNote":
    "أنت ضابط سلسلة يدوية في الموديلات والمزوّدين، وبتتستخدم لما الموديل الأساسي يفشل. القايمة تحت هي اللي الترتيب التلقائي هيستخدمها.",
  "wf.order": "الترتيب",
  "wf.orderHint":
    "أول موديل بيرد؛ لو فشل قبل ما يرد بينتقل للي بعده (لحد {n} بدائل). الصفوف الباهتة بره الحد ده.",
  "wf.empty":
    "مفيش موديلات صالحة لنوع الطلب ده. ضيف مفتاح مزوّد أو فعّل مزوّد في الموديلات والمزوّدين.",
  "wf.health": "حالة المزوّد (آخر فحص)",
  "wf.noData": "مفيش بيانات",
  "wf.strength": "القوة",
  "wf.legend":
    "الشريط = تقدير القدرة · ⚡ = السرعة · العين = رؤية · المخ = تفكير · المفتاح = أدوات · % = نسبة النجاح الفعلية على النسخة دي.",
  "settings.models": "النماذج والمزوّدون",
  "settings.security": "الأمان",
  "settings.about": "حول",

  "general.appearance": "المظهر",
  "general.language": "اللغة",
  "general.theme": "السمة",
  "general.dark": "داكن",
  "general.light": "فاتح",
  "general.system": "النظام",
  "general.accent": "لون التمييز",
  "general.accentHint": "بيُستخدم للأزرار والتمييز والشعار.",
  "general.customColor": "لون مخصص",
  "general.density": "الكثافة",
  "general.comfortable": "مريحة",
  "general.compact": "مضغوطة",
  "general.fontSize": "حجم النص",
  "general.small": "صغير",
  "general.medium": "متوسط",
  "general.large": "كبير",
  "general.instructions": "تعليمات مخصصة",
  "general.instructionsHint": "بتتضاف لكل محادثة. عرّف AI بدورك وأسلوبك وتفضيلاتك.",
  "general.instructionsPlaceholder":
    "مثال: أنا محلل WFM. فضّل الإجابات المختصرة مع جداول. رد بالعامية المصرية لما أكتب بالعربي.",

  "profile.account": "الحساب",
  "profile.signOut": "تسجيل الخروج",
  "profile.signOutHint": "تسجيل الخروج من الجهاز ده.",
  "security.password": "تغيير كلمة المرور",
  "security.passwordHint": "تغيير كلمة المرور بيسجّل خروجك من كل الأجهزة التانية.",
  "security.current": "كلمة المرور الحالية",
  "security.new": "كلمة المرور الجديدة",
  "security.changed": "تم تحديث كلمة المرور.",
  "security.sessions": "الجلسات النشطة",
  "security.sessionsHint": "الأجهزة المسجّل دخولها على حسابك دلوقتي.",
  "security.current_badge": "الجهاز ده",
  "security.revoke": "تسجيل خروج",
  "about.body":
    "AI مساعد ذكاء اصطناعي مملوك لك بالكامل. النماذج قابلة للتبديل: غيّر المزوّد من الإعدادات ← النماذج والمزوّدون من غير أي تعديل في الكود.",

  "models.intro": "اربط أي مزوّد نماذج. المفاتيح بتتخزن مشفّرة ومبتظهرش تاني بعد الحفظ.",
  "models.add": "إضافة مزوّد",
  "models.edit": "تعديل المزوّد",
  "models.emptyTitle": "لسه مفيش مزوّدين",
  "models.emptyHint":
    "ضيف Claude، أو واجهة متوافقة مع OpenAI (RunPod وOllama وOpenRouter وDeepSeek…) أو Workers AI.",
  "models.keySaved": "المفتاح محفوظ",
  "models.noKey": "بدون مفتاح",
  "models.enabled": "مفعّل",
  "models.moveUp": "فوق",
  "models.moveDown": "تحت",
  "models.refresh": "تحديث قايمة الموديلات",
  "models.refreshing": "بيتأكد…",
  "models.refreshed": "اتحدّثت القايمة: {total} موديل متاح، {added} جديد، {removed} اتشال.",
  "billing.yes": "ممكن يطلب فلوس",
  "billing.maybe": "مجاني لحد حد معين وبعدين مدفوع",
  "billing.reason.paid": "المزوّد ده مدفوع.",
  "billing.reason.credits": "رصيد أو حصة مجانية بس، وأي استخدام بعدها بيتحاسب.",
  "billing.reason.card": "لازم تضيف وسيلة دفع عشان الـ API يشتغل.",
  "billing.reason.upgrade": "الخطة المجانية ما فعّلتش مفاتيح الـ API، والترقية مدفوعة.",
  "billing.reason.workers": "حصة يومية مجانية وبعدها بتتحاسب على حساب Cloudflare بتاعك.",
  "usage.today": "النهارده",
  "usage.month": "الشهر ده",
  "usage.requests": "طلب",
  "usage.tokens": "توكن",
  "usage.usedOf": "مستخدم {used} من {total}",
  "usage.reportedAt": "الحصة اللي المزوّد بلّغ بيها الساعة {time} (بتتحدّث بعد كل طلب).",
  "models.viewMore": "عرض المزيد (+{n})",
  "models.viewLess": "عرض أقل",
  "models.probe": "اختبار كل الموديلات",
  "models.probing": "بيختبر الموديلات… (لحد دقيقة)",
  "models.probeConfirm":
    "ده هيبعت طلب صغير جداً لكل موديل (بيستهلك توكنز مجانية قليلة)، ويشيل اللي مش شغّال على حسابك، ويحدد مين بيدعم الأدوات. نكمّل؟",
  "models.probed": "{working} من {probed} موديل شغّال · {tools} بيدعم الأدوات · {removed} اتشال.",
  "models.test": "اختبار الاتصال",
  "models.testOk": "تمام · {ms} ms · {model}",
  "models.deleteTitle": "حذف المزوّد؟",
  "models.deleteBody":
    "“{name}” ومفتاحه المخزّن هيتحذفوا. المحادثات اللي بتستخدمه هتحتاج نموذج تاني.",
  "models.formHint": "اختار قالب جاهز يملّي البيانات، وبعدين حط مفتاح الـ API.",
  "models.preset": "ابدأ من قالب جاهز",
  "models.presetPick": "اختر قالب…",
  "models.name": "الاسم المعروض",
  "models.type": "نوع المزوّد",
  "models.baseUrl": "الرابط الأساسي (Base URL)",
  "models.baseUrlHint": "https فقط (http مسموح لـ localhost)",
  "models.accountId": "معرّف حساب Cloudflare",
  "models.apiKey": "مفتاح الـ API",
  "models.instructions": "برومبت التوجيه (للمزوّد ده بس)",
  "models.instructionsPh": "مثال: رد دايمًا بلغة المستخدم. ممنوع أي حروف صينية إلا لو اتطلبت…",
  "models.instructionsNote":
    "بيتضاف لتعليمات النظام في كل طلب بيتبعت للمزوّد ده بس. باقي المزوّدين مش بيتأثروا. خليه قصير مع الموديلات المحلية الصغيرة.",
  "models.keyKeep": "سيبه فاضي للإبقاء على المفتاح المحفوظ",
  "models.keyNote": "بيتخزن مشفّر (AES-GCM) ومبيترجعش للمتصفح أبدًا.",
  "models.keyRemove": "حذف المفتاح المحفوظ",
  "models.models": "النماذج",
  "models.modelId": "معرّف النموذج",
  "models.priceIn": "$/مليون إدخال",
  "models.priceOut": "$/مليون إخراج",
  "models.addModel": "إضافة نموذج",
  "models.priceNote": "الأسعار اختيارية وبتُستخدم لتتبّع التكلفة.",
  "models.capabilities": "القدرات",
  "models.maxContext": "نافذة السياق (توكن)",
  "cap.tools": "استدعاء الأدوات",
  "cap.vision": "الرؤية",
  "cap.thinking": "التفكير",
  "cap.audio": "الصوت",
  "cap.promptCaching": "تخزين الـ Prompt مؤقتًا",

  "routing.title": "النموذج الافتراضي والبدائل",
  "routing.hint":
    "لو النموذج المختار فشل قبل ما يرد، AI بيجرّب تلقائيًا النموذج اللي بعده في السلسلة.",
  "routing.default": "النموذج الافتراضي للمحادثات الجديدة",
  "routing.tasks": "موديل لكل نوع شغل",
  "routing.tasksHint":
    "اختار موديل لكل نوع شغل، أو تلقائي (أحسن موديل مجاني حسب النتايج الفعلية؛ التلقائي عمره ما بيستخدم موديل مدفوع).",
  "routing.task.chat": "المحادثة",
  "routing.task.agent": "تشغيلات الوكيل (أدوات)",
  "routing.task.assistant": "محادثات المساعد",
  "routing.task.telegram": "تيليجرام",
  "routing.task.background": "مساعدين الخلفية (ذاكرة، قواعد)",
  "routing.taskInherit": "زي الافتراضي (أو موديل المساعد لتيليجرام)",
  "routing.taskAuto": "تلقائي: أحسن مجاني حسب النتايج",
  "routing.nowUses": "اللي بيستخدمه كل نوع شغل دلوقتي",
  "routing.why.task": "اختيارك لنوع الشغل ده",
  "routing.why.assistant": "موديل المساعد",
  "routing.why.default": "الموديل الافتراضي",
  "routing.why.auto": "تلقائي (أحسن مجاني)",
  "routing.why.none": "أول موديل متاح",
  "routing.success": "{n}% من الطلبات الأخيرة نجحت",
  "routing.assistant": "نموذج محادثات المساعد مع الناس",
  "routing.assistantSame": "نفس النموذج الافتراضي",
  "routing.assistantHint":
    "بيتستخدم لما المساعد يصيغ طلباتك ويرد على الناس بدالك. اختار أقوى نموذج عندك (العربي الكويس مهم هنا).",
  "routing.firstAvailable": "أول نموذج متاح",
  "routing.chain": "سلسلة البدائل",
  "routing.chainEmpty": "مفيش بدائل. ضيف نماذج تحت علشان تفضل شغال لو مزوّد وقع.",
  "routing.addToChain": "إضافة نموذج بديل…",
  "composer.agent": "وكيل",
  "composer.plan": "خطة",
  "composer.planHint": "وضع الخطة: الوكيل يقترح خطة ولا ينفّذ أدوات ذات أثر جانبي",
  "agent.sandboxOffline": "الـ Sandbox غير متصل",
  "agent.sandboxOfflineHint":
    "مفيش Runner على الـ Raspberry Pi متصل. البحث والجلب من الويب شغالين، لكن تنفيذ الكود والملفات لأ.",
  "agent.needsApproval": "يحتاج موافقة",
  "agent.result": "النتيجة",
  "agent.approvalTitle": "الوكيل عايز ينفّذ:",
  "agent.approve": "موافقة",
  "agent.deny": "رفض",
  "agent.always": "اسمح دايمًا في المحادثة دي",
  "agent.progress": "التقدم",
  "agent.working": "شغّال…",
  "agent.interrupted": "التشغيل ده اتقطع (السيرفر اتعمله restart). تقدر تكمّله.",
  "agent.resume": "استئناف",
  "settings.tools": "الأدوات والصلاحيات",
  "settings.runner": "الـ Runner (Pi)",
  "tools.search": "البحث على الويب",
  "tools.searchHint": "الوكلاء بيبحثوا عبر المزوّد اللي تختاره. المفتاح بيتخزن مشفّر ومبيظهرش تاني.",
  "tools.notConfigured": "غير مُعدّ",
  "tools.provider": "المزوّد",
  "tools.permissions": "صلاحيات الأدوات",
  "tools.permissionsHint":
    "اسأل = تأكيد كل مرة · اسمح = تشغيل تلقائي · ارفض = أبدًا. وتقدر تسمح لأداة في محادثة واحدة بس من نافذة الموافقة.",
  "tools.runnerOffline":
    "مفيش Runner متصل: أدوات الـ Sandbox غير متاحة. اربط الـ Raspberry Pi من الإعدادات ← Runner.",
  "tools.ask": "اسأل",
  "tools.allow": "اسمح",
  "tools.deny": "ارفض",
  "runner.intro":
    "الـ Runner خدمة صغيرة على الـ Raspberry Pi بتنفّذ الكود وأدوات الملفات جوه Docker sandboxes مؤقتة. هو اللي بيتصل بالتطبيق — مفيش أي حاجة مكشوفة على شبكتك. من غيره التطبيق بيشتغل عادي (محادثة، بحث، توليد ملفات) بس تنفيذ الكود مش متاح.",
  "runner.status": "الـ Runners المتصلة",
  "runner.online": "متصل",
  "runner.offline": "غير متصل",
  "runner.noneTitle": "مفيش Runner مربوط",
  "runner.noneHint": "ولّد كود ربط من تحت وشغّل أمر واحد على الـ Pi.",
  "runner.pairTitle": "ربط Raspberry Pi",
  "runner.pairHint":
    "شغّل الأمر على الـ Pi (Raspberry Pi OS 64-bit والـ HDD متركّب). بيثبّت Docker لو مش موجود، ويبني الـ sandbox، ويشغّل الـ runner.",
  "runner.switchTitle": "استخدام الـ sandbox لتشغيل الكود",
  "runner.switchHint":
    "بيشغّل أو بيقفل أدوات الـ sandbox (Python وshell والملفات) في وضع Agent. الـ runner نفسه بيفضل شغّال على جهازك، وبتوقفه أو تشيله بالأوامر اللي تحت.",
  "runner.switchOn": "شغّال - الـ Agent يقدر ينفّذ كود",
  "runner.switchOff": "مقفول - أدوات الكود مخفية عن الـ Agent",
  "runner.haTitle": "Home Assistant / أوامر جاهزة",
  "runner.haHint":
    "شغّلها في إضافة Advanced SSH & Web Terminal (Protection mode مقفول). ولّد كود الربط من فوق الأول، وهيتحط تلقائي تحت.",
  "runner.haEnable": "التفعيل / الربط (بدّل XXXX-XXXX بكود جديد)",
  "runner.haLocalAi":
    "تفعيل + ذكاء اصطناعي محلي بيشتغل من غير إنترنت (بيختار موديل صغير على حسب الرام والمساحة)",
  "runner.haRestartAi": "تشغيل تاني بعد إعادة التشغيل (مع الذكاء المحلي)",
  "runner.haRestart": "تشغيله تاني (بعد إعادة تشغيل الجهاز)",
  "runner.haStop": "إيقافه",
  "runner.haRemove": "إزالته نهائياً",
  "runner.haNote":
    "بعد ما تشيل الـ runner، فعّل Protection mode تاني في الإضافة. على Raspberry Pi عادي استخدم أمر install اللي في قسم الربط بدل ده.",
  "runner.generate": "توليد أمر الربط",
  "runner.runOnPi": "شغّل على الـ Raspberry Pi:",
  "runner.codeExpires": "الكود بيشتغل مرة واحدة وبينتهي بعد 15 دقيقة.",
  "composer.attach": "إرفاق ملفات أو صور",
  "composer.uploading": "جاري الرفع…",
  "composer.lookAttached": "لو سمحت بص على الملف/الملفات المرفقة.",
  "nav.artifacts": "المستندات",
  "artifacts.emptyTitle": "لسه مفيش مستندات",
  "artifacts.emptyHint":
    "اطلب من AI في وضع الوكيل ينشئ مستند أو جدول أو عرض تقديمي أو صفحة ويب أو رسم أو ملف كود — وهيظهر هنا.",
  "artifact.panel": "مستند",
  "artifact.untitled": "بدون عنوان",
  "artifact.updated": "تحديث المستند",
  "artifact.failed": "تعذّر إنشاء المستند",
  "voice.title": "وضع الصوت",
  "voice.listening": "سامعك…",
  "voice.hearing": "بسمعك…",
  "voice.transcribing": "بحوّل الكلام لنص…",
  "voice.thinking": "بفكّر…",
  "voice.gemini": "صوت طبيعي (Gemini، مجاني)",
  "voice.geminiHint":
    "بيستخدم مفتاح Google Gemini بتاعك (الباقة المجانية) عشان يتكلم بصوت طبيعي أكتر بكتير وبنفس اللهجة (مصري، سعودي، خليجي، شامي…). لو مش متاح أو خلّصت الحصة المجانية اليومية، الصوت اللي فوق بياخد مكانه تلقائي.",
  "voice.readAloud": "قراءة الردود بصوت عالي",
  "voice.repliesVoice": "الردود: صوت",
  "voice.repliesText": "الردود: نص",
  "voice.speaking": "بتكلّم… (اضغط عشان تقاطعني)",
  "voice.muted": "المايك مقفول",
  "voice.mute": "اقفل المايك",
  "voice.unmute": "افتح المايك",
  "voice.end": "إنهاء",
  "voice.noMic": "مش قادر أوصل للمايك",
  "voice.unsupported":
    "التعرف على الكلام مش متاح في المتصفح ده — اختار خيار من السيرفر في الإعدادات ← الصوت",
  "voice.dictate": "إملاء صوتي",
  "voice.stopDictation": "إيقاف الإملاء",
  "settings.voice": "الصوت",
  "voice.settings.sttSpeechOnly":
    "المزوّد اللي اخترته للتفريغ الصوتي بيتكلم بس ومبيعرفش يفرّغ الصوت لنص. بنستخدم Whisper المدمج بدله؛ اختار Workers AI أو مزوّد تاني عشان التحذير ده يختفي.",
  "voice.settings.stt": "تحويل الكلام لنص (صوتك ← نص)",
  "voice.settings.tts": "تحويل النص لكلام (قراءة الردود بصوت عالي)",
  "voice.settings.lang": "اللغة",
  "voice.settings.langAuto": "تلقائي (حسب لغة الواجهة)",
  "voice.settings.src.browser": "المتصفح ده (مجاني، من غير سيرفر)",
  "voice.settings.src.workers-ai": "Workers AI Whisper",
  "voice.settings.src.provider": "مزوّد / سيرفر الصوت على الـ Pi",
  "voice.settings.provider": "المزوّد",
  "voice.settings.providerNone": "— اختار —",
  "voice.settings.model": "الموديل",
  "voice.settings.voice": "اسم الصوت",
  "voice.settings.piHint":
    "على الـ Pi: ضيف مزوّد بعنوان runner://voice/v1 (الإعدادات ← الموديلات) بعد ما تشغّل الـ installer ببروفايل الصوت.",
  "voice.settings.testSpeak": "جرّب الصوت",
  "voice.settings.testing": "بشغّل…",
  "voice.settings.sample": "Hello! This is AI speaking.",
  "voice.settings.sampleAr": "أهلاً! أنا AI.",
  "voice.settings.saved": "اتحفظ",
  "voice.settings.workersAiOff": "Workers AI مش متاح في النشر ده.",
  "voice.settings.runnerOffline": "الـ Runner بتاع الـ Pi أوفلاين.",
  "cost.free": "مجاني",
  "cost.quota": "مجاني لحد حصة، وبعدها مدفوع",
  "cost.paid": "مدفوع",
  "cost.label": "التكلفة",
  "cost.freeHint": "من غير تكلفة (باقة مجانية أو على جهازك)",
  "cost.quotaHint": "حصة مجانية الأول وبعدها بتتحاسب على حسابك",
  "cost.paidHint": "بيتكلف فلوس مع كل استخدام (أو التكلفة مش معروفة)",
  "models.getKey": "هات مفتاح مجاني ↗",
  "routing.waterfall": "التبديل التلقائي (Waterfall)",
  "routing.waterfallHint": "لو الموديل وقع أو خلصت حصته قبل ما يرد، بيجرّب اللي بعده لوحده.",
  "routing.mode": "الترتيب",
  "routing.mode.auto": "تلقائي",
  "routing.mode.auto.hint": "كل الموديلات المتاحة من الأقوى للأضعف.",
  "routing.mode.manual": "يدوي",
  "routing.mode.manual.hint": "الموديلات اللي تختارها بس، بالترتيب اللي تحطه.",
  "routing.freeOnly": "الموديلات المجانية بس",
  "routing.freeOnlyHint": "ماينقلش أبدًا لموديل بيتكلف فلوس.",
  "routing.paidWarning": "تحذير: لو قفلت ده، التبديل ممكن يستخدم موديلات مدفوعة وتتخصم فلوس.",
  "routing.effective": "الترتيب اللي هيتجرّب بعد الموديل اللي اخترته",
  "routing.effectiveEmpty":
    "مفيش موديلات تانية لسه. ضيف مزوّدين مجانيين فوق عشان يتكوّن الـ waterfall.",
  "routing.sortByStrength": "رتّب من الأقوى",
  "routing.up": "فوق",
  "routing.down": "تحت",
  "toggle.language": "تغيير اللغة",
  "toggle.light": "التحويل للثيم الفاتح",
  "toggle.dark": "التحويل للثيم الغامق",
  "auth.passkey": "الدخول بالبصمة / Passkey",
  "passkeys.title": "Passkeys (بصمة، وش، أو PIN الجهاز)",
  "passkeys.hint":
    "ادخل ببصمة جهازك بدل الباسورد. الـ passkey بيتحسب كمان خطوة تحقق تانية. سجّلها على العنوان اللي بتستخدمه فعلًا (الـ passkey مربوطة بعنوان الموقع).",
  "passkeys.unsupported": "المتصفح أو الجهاز ده مش بيدعم الـ passkeys.",
  "passkeys.add": "ضيف passkey",
  "passkeys.namePlaceholder": "الاسم (مثلًا موبايلي)",
  "passkeys.synced": "متزامنة مع أجهزتك",
  "passkeys.used": "اتستخدمت",
  "instance.title": "الحسابات والدخول (للمالك)",
  "instance.hint": "الإعدادات دي بتنطبق على كل اللي بيستخدموا النسخة دي.",
  "instance.signup": "السماح بتسجيل حسابات جديدة",
  "instance.signupHint":
    "مقفول: الحسابات الموجودة بس هي اللي تدخل. مفتوح: أي حد معاه اللينك يقدر يعمل حساب.",
  "instance.require2fa": "إلزام الكل بخطوة تحقق تانية",
  "instance.require2faHint":
    "كل حساب لازم يستخدم تطبيق مصادقة أو passkey. الحسابات اللي معندهاش بتتطلب منها الإعداد قبل استخدام التطبيق.",
  "require2fa.title": "أمّن حسابك",
  "require2fa.body":
    "المالك مفعّل خطوة تحقق تانية للدخول. ضيف passkey (بصمة / وش / PIN) أو تطبيق مصادقة عشان تكمل.",
  "require2fa.done": "خلصت الإعداد — كمّل",
  "quota.title": "حصة Workers AI اليومية",
  "quota.source.cloudflare": "دقيق (من Cloudflare)",
  "quota.source.cloudflare.hint": "مقروء من تحليلات Cloudflare لحسابك كله",
  "quota.source.estimate": "تقديري",
  "quota.source.estimate.hint":
    "محسوب من استخدامك جوه التطبيق بس. ضيف CF_ACCOUNT_ID و CF_ANALYTICS_TOKEN على الـ Worker عشان تاخد أرقام دقيقة لحسابك كله.",
  "quota.paused": "اتوقف تلقائيًا",
  "quota.used": "المستخدم النهارده (neurons)",
  "quota.remaining": "المتبقي",
  "quota.limit": "حدّك اليومي",
  "quota.day": "يوم",
  "quota.resets": "التجديد",
  "quota.resetsHint": "بيتجدد كل يوم الساعة 00:00 UTC ({time} بتوقيتك)",
  "quota.in": "بعد {left}",
  "quota.free":
    "الحصة المجانية: {n} neuron في اليوم، وبعدها {rate} لكل 1,000 neuron على حساب Cloudflare بتاعك.",
  "quota.overage": "عدّيت الحصة المجانية بـ {n} neuron النهارده — حوالي {usd} هتتحاسب.",
  "quota.guard": "الإيقاف التلقائي",
  "quota.guardHint": "وقّف Workers AI تلقائيًا عند {pct}% من حدّك اليومي (برجع بعد التجديد).",
  "quota.threshold": "أوقف عند",
  "quota.dailyLimit": "الحد اليومي (neurons)",
  "quota.limitHint":
    "الحد اليومي الافتراضي هو الـ 10,000 neuron المجانية. رفعه معناه سماح باستخدام مدفوع — سيبه على المجاني لو مش عايز تدفع أبدًا.",
  "quickkey.title": "محتاج مفتاح مجاني عشان يشتغل",
  "quickkey.hint":
    "اعمل حساب مجاني عند المزوّد، انسخ الـ API key والصقه هنا. لحد وقتها الـ waterfall بيتخطى المزوّد ده.",
  "quickkey.placeholder": "الصق الـ API key",
  "quickkey.needsKey": "محتاج مفتاح",
  "settings.system": "المستخدمين والوصول",
  "settings.systemGroup": "النظام (للمالك فقط)",
  "users.title": "المستخدمين",
  "users.hint": "كل اللي عندهم حساب على النسخة دي. إنت بس (المالك) اللي بتشوف الصفحة دي.",
  "users.owner": "المالك",
  "users.user": "مستخدم",
  "users.disabled": "محظور",
  "users.has2fa": "التحقق بخطوتين شغّال",
  "users.no2fa": "من غير تحقق بخطوتين",
  "users.joined": "انضم",
  "users.lastLogin": "آخر دخول",
  "users.disable": "حظر",
  "users.enable": "فك الحظر",
  "users.reset2fa": "إعادة ضبط التحقق",
  "users.deleteTitle": "تمسح المستخدم ده؟",
  "users.deleteBody": "{name} وكل محادثاته وملفاته ومزوّديه هيتمسحوا نهائيًا.",
  "users.stat.total": "الحسابات",
  "users.stat.online": "أونلاين دلوقتي",
  "users.stat.24h": "نشط (24 ساعة)",
  "users.stat.7d": "نشط (7 أيام)",
  "users.stat.30d": "نشط (30 يوم)",
  "users.stat.active": "غير محظور",
  "users.stat.disabled": "محظور",
  "users.stat.no2fa": "من غير تحقق بخطوتين",
  "users.online": "أونلاين دلوقتي",
  "users.offline": "أوفلاين",
  "users.seen": "آخر ظهور",
  "users.chats": "محادثة",
  "users.tokens": "توكن الشهر ده",
  "users.activity": "النشاط",
  "users.devices": "الأجهزة والجلسات",
  "users.noSessions": "مفيش جلسات شغّالة",
  "users.events": "آخر الأحداث",
  "general.black": "أسود (محايد)",
  "general.themeHint": "كل خلفية ليها لون مميز خاص بيها؛ اختار لون من تحت لو عايز تغيّره.",
  "palette.qn": "QN (الأساسي)",
  "palette.dark": "منتصف الليل",
  "palette.black": "أسود",
  "palette.graphite": "جرافيت",
  "palette.warm": "دافئ",
  "palette.forest": "غابة",
  "palette.ocean": "محيط",
  "palette.wine": "نبيذي",
  "palette.aurora": "شفق",
  "palette.neon": "نيون",
  "palette.sunrise": "شروق",
  "palette.light": "فاتح",
  "palette.paper": "ورقي",
  "palette.mist": "ضبابي",
  "replies.title": "إزاي الـ AI بيرد",
  "replies.hint": "بيتطبّق على كل المحادثات وتشغيلات الـ Agent.",
  "replies.language": "لغة / لهجة الرد",
  "replies.languageHint": "تلقائي = يرد بنفس اللغة واللهجة اللي بتكتب بيها.",
  "replies.lang.auto": "تلقائي (زيّي)",
  "replies.lang.ar-eg": "مصري (عامية)",
  "replies.lang.ar-baladi": "مصري بلدي",
  "replies.lang.ar-saidi": "صعيدي",
  "replies.lang.ar-levant": "شامي",
  "replies.lang.ar-gulf": "خليجي",
  "replies.lang.ar-maghreb": "مغربي (دارجة)",
  "replies.lang.ar-fusha": "فصحى",
  "replies.lang.en": "English",
  "replies.lang.fr": "Français",
  "replies.lang.es": "Español",
  "replies.lang.de": "Deutsch",
  "replies.lang.tr": "Türkçe",
  "replies.tone": "الأسلوب",
  "replies.tone.balanced": "متوازن",
  "replies.tone.concise": "مختصر ومباشر",
  "replies.tone.detailed": "تفصيلي",
  "replies.tone.friendly": "ودود",
  "replies.tone.formal": "رسمي",
  "replies.emoji": "السماح بالإيموجي في الردود",
  "replies.emojiHint": "مقفول افتراضيًا لشكل أكتر احترافية.",
  "interface.title": "الواجهة",
  "interface.sendOnEnter": "الإرسال بزر Enter",
  "interface.sendOnEnterHint": "مقفول: Enter بينزّل سطر جديد، والإرسال بـ Ctrl/Cmd+Enter.",
  "interface.width": "عرض المحادثة",
  "interface.width.narrow": "ضيّق",
  "interface.width.normal": "عادي",
  "interface.width.wide": "واسع",
  "interface.font": "خط القراءة",
  "interface.font.sans": "بدون زوائد (Sans)",
  "interface.font.serif": "بزوائد (Serif)",
  "interface.font.mono": "ثابت العرض",
  "interface.reduceMotion": "تقليل الحركة",
  "interface.showUsage": "عرض التوكنز والتكلفة تحت الرد",
  "interface.showUsageHint": "سطر الاستهلاك لكل رسالة.",
  "suggest.fromHistory": "بناءً على آخر طلباتك — تقدر تغيّر ده من الإعدادات ← عام.",
  "suggest.listLabel": "اقتراحات",
  "suggest.hint": "Tab للقبول · ↑↓ للاختيار · Esc للإغلاق",
  "suggest.title": "الاقتراحات",
  "suggest.settingsHint":
    "الاقتراحات في شاشة المحادثة الفاضية والإكمال التلقائي زي جوجل وإنت بتكتب.",
  "suggest.starters": "اقتراحات من تاريخي",
  "suggest.startersHint": "اعرض آخر طلباتي بدل أمثلة ثابتة.",
  "suggest.autocomplete": "إكمال تلقائي وأنا بكتب",
  "suggest.autocompleteHint": "بيكمّل جملتك من اللي كتبته قبل كده، بنفس لغتك ولهجتك.",
  "suggest.ai": "إكمال ذكي بالـ AI",
  "suggest.aiHint":
    "كمان بيسأل موديل مجاني يقترح عليك لما توقف لحظة (نداء صغير لكل مرة؛ مش موديل مدفوع أبدًا).",
  "suggest.history": "افتكر طلباتي",
  "suggest.historyHint": "لازم عشان الاقتراحات الشخصية. بتتخزن في حسابك بس.",
  "suggest.cleared": "اتمسح {n} طلب من الذاكرة الساعة {time}.",
  "suggest.nothing": "مفيش حاجة تتمسح - التاريخ فاضي أصلاً.",
  "suggest.clear": "امسح التاريخ",
  "style.title": "نمط التصميم",
  "style.modern": "عصري",
  "style.modern.hint": "توهّج ألوان ناعم وكروت مدوّرة — الشكل المميز.",
  "style.classic": "كلاسيكي",
  "style.classic.hint": "مسطّح وهادي، زي ChatGPT أو Claude.",
  "style.glass": "زجاجي",
  "style.glass.hint": "شفاف وضبابي ومدوّر، زي iOS.",
  "defaults.title": "الإعدادات الافتراضية للكل",
  "defaults.hint": "اللي كل حساب بياخده لحد ما صاحبه يختار حاجة تانية. فاضي = الافتراضي المدمج.",
  "defaults.builtIn": "الافتراضي المدمج",
  "defaults.on": "شغّال",
  "defaults.off": "مقفول",
  "defaults.applyAll": "طبّق على الكل دلوقتي",
  "defaults.applyAllHint":
    "بيمسح اختيارات كل اليوزرز الخاصة بالإعدادات دي فكل الحسابات ترجع تمشي على الافتراضي.",
  "defaults.applied": "تمّ — {n} حساب اترجع للافتراضي.",
  "defaults.confirmBody": "اختيارات كل مستخدم الخاصة بالإعدادات اللي فوق هتتمسح. مفيش رجوع.",
  "install.button": "ثبّت التطبيق",
  "install.installed": "متثبّت كتطبيق على الجهاز ده.",
  "install.hint": "تقدر تثبّته كتطبيق: من قايمة المتصفح اختار تثبيت / إضافة للشاشة الرئيسية.",
  "instance.learn": "التعلّم من المحادثات",
  "instance.learnHint":
    "المساعد بيفتكر التفضيلات والتصحيحات الدائمة (اللغة، اللهجة، الشكل) من رسايل كل مستخدم ويستخدمها في الشاتات الجاية. المستخدم يقدر يشوف ذكرياته ويمسحها.",
  "instance.selfImprove": "التطوير الذاتي (توجيه تكيّفي)",
  "instance.selfImproveHint":
    "بيتابع أنهي موديل بينجح فعلاً عندك ويرفع الموديلات الموثوقة تلقائياً في الـ waterfall المجاني. مبيغيّرش كود ومبيصرفش فلوس.",
  "voice.noSignal": "مش سامع أي صوت من الميكروفون. اتأكد من إذن الميكروفون وإنه مش مكتوم.",
  "voice.noSpeech": "مسمعتش كويس — جرّب تاني وقرّب من الميكروفون.",
  "voice.auto": "اكتشاف اللهجة تلقائياً",
  "voice.autoHint":
    "بيكتشف لهجة كل رد (مصري، سعودي، شامي، خليجي، مغربي، إنجليزي…) وبيقراه بصوت مناسب ليها.",
  "voice.gender": "الصوت",
  "voice.gender.female": "بنت",
  "voice.gender.male": "ولد",
  "voice.deviceHint":
    "الأصوات المثبّتة على جهازك. الأصوات المصرية بتكون غالباً على Android/Chrome وWindows؛ ولو عاوز صوت بنت مصرية مضمون استخدم Azure Speech تحت.",
  "voice.azure.title": "أصوات طبيعية: Azure Speech (فيه شريحة مجانية)",
  "voice.azure.hint":
    "واجهة Microsoft Azure Speech الرسمية فيها 40+ صوت عربي، ولاد وبنات، كل اللهجات (مصري سلمى/شاكر، سعودي، سوري، لبناني، خليجي، مغربي…) غير الإنجليزي وغيره. اعمل Speech resource مجاني في بوابة Azure والصق الـ region والمفتاح؛ المفتاح بيتخزن مشفّر وما بيتعرضش تاني.",
  "voice.azure.region": "منطقة Azure",
  "voice.azure.key": "مفتاح Azure Speech",
  "voice.azure.add": "ربط",
  "interface.lockZoom": "قفل الزوم (زي التطبيق)",
  "interface.lockZoomHint":
    "بيمنع الزوم بالصباعين والضغط المزدوج عشان التطبيق يتصرف زي أي تطبيق عادي. لو عاوز خط أكبر استخدم حجم الخط فوق.",
  "update.available": "في نسخة جديدة متاحة.",
  "update.reload": "إعادة تحميل",
  "update.check": "التحقق من التحديثات",
  "update.force": "إعادة تحميل إجبارية",
  "update.latest": "أنت على آخر نسخة.",
  "update.auto": "حدّث تلقائياً لما أرجع للتطبيق",
  "notif.settingsTitle": "الإشعارات",
  "notif.hint": "اعرف على الجهاز ده لما مهمة طويلة تخلص، حتى والتطبيق مقفول.",
  "notif.unsupported":
    "المتصفح ده مبيدعمش الإشعارات في الخلفية. إشعارات التطبيق (الجرس) شغالة عادي.",
  "notif.device": "إشعارات على الجهاز ده",
  "notif.iosHint":
    "على iPhone/iPad: مشاركة ← إضافة إلى الشاشة الرئيسية، وبعدين افتح التطبيق من الشاشة الرئيسية وشغّل الخيار ده.",
  "notif.master": "السماح بإشعارات الخلفية",
  "notif.masterHint": "بتنطبق على كل أجهزتك.",
  "notif.runDone": "مهمة أو محادثة خلصت",
  "notif.approval": "أداة محتاجة موافقتي",
  "notif.assistant": "أحداث المساعد (ردود، مكالمات اترفضت، مهام محتاجاك)",
  "notif.calls": "مكالمات المساعد الواردة",
  "notif.quiet": "ساعات الهدوء للإشعارات الخلفية",
  "notif.quietHint":
    "مفيش إشعار على الموبايل بين الساعتين دول (بتوقيتك من إعدادات المساعد)، والقايمة اللي في الجرس بتتملي عادي. المكالمات مبتتسكتش.",
  "notif.quietFrom": "من",
  "notif.quietTo": "إلى",
  "notif.clearRead": "امسح المقروء",
  "notif.failures": "مهمة أو جدولة فشلت",
  "notif.test": "ابعت إشعار تجريبي",
  "notif.devices": "{n} جهاز متصل",
  "notif.testSent": "اتبعت — المفروض يوصل خلال ثواني.",
  "notif.testNone": "مفيش حاجة اتسلّمت. شغّل 'إشعارات على الجهاز ده' الأول.",
  "voice.issue.noVoice":
    "مفيش صوت للغة دي متثبّت على جهازك. iPhone: الإعدادات ← تسهيلات الاستخدام ← المحتوى المنطوق ← الأصوات.",
  "voice.issue.noVoiceAr":
    "مفيش صوت عربي متثبّت على جهازك. iPhone: الإعدادات ← تسهيلات الاستخدام ← المحتوى المنطوق ← الأصوات ← العربية (نزّل صوت)، أو اربط Azure Speech تحت لأصوات عربية طبيعية.",
  "voice.issue.silent":
    "الجهاز مشغّلش أي صوت. اتأكد من زرار الصامت (Silent) والصوت، وإنك ضغطت على الزرار بنفسك.",
  "upload.drop": "اسحب الملفات هنا لإرفاقها",
  "upload.dropHint": "Excel وPowerPoint وWord وPDF ونصوص وCSV وصور — المساعد بيقراهم.",
  "interface.imageSafe": "الوضع الآمن للصور",
  "interface.imageSafeHint":
    "شغّال: الطلبات اللي فيها ألفاظ صريحة بتترفض وبتتضاف إشارة 'مناسب للعمل'. مقفول: بيشتغل بس فلتر مزوّد الصور نفسه (مفيد للفن والتشريح والأزياء والمواضيع الطبية). المحتوى الجنسي مبيتولّدش في الحالتين.",
  "composer.image": "صورة",
  "mode.title": "عايز أعمل إيه",
  "mode.auto": "تلقائي",
  "mode.auto.hint": "التطبيق بيقرر: صورة أو ملف أو رد عادي، ويحوّل لموديل يقدر ينفّذ الطلب.",
  "mode.text": "نص فقط",
  "mode.text.hint": "مبيولّدش صور أبداً؛ كل رسالة شات عادي.",
  "mode.image": "صورة",
  "mode.image.hint": "كل رسالة بتتحوّل لصورة (اوصف اللي عايزه).",
  "instance.learnRules": "اتعلّم قواعد من تعليماتي",
  "instance.learnRulesHint":
    'لما أنت (الـ owner) تدّي المساعد تعليمة دائمة في الشات — زي "من دلوقتي متردش غير على أسئلة الـ workforce" — بتتحوّل لقاعدة على كل المستخدمين. بيجيلك إشعار وتقدر توقفها من تحت. هي بتغيّر السلوك عن طريق الـ system prompt مش الكود.',
  "rules.title": "قواعد المساعد (لكل المستخدمين)",
  "rules.hint":
    "قواعد دائمة بتتضاف لكل شاتات وتشغيلات الـ Agent عند كل المستخدمين. المساعد بيلتزم بيها ويرفض الطلبات اللي بتخالفها. هي بتوجّه الموديل، مش حاجز تقني قاطع.",
  "rules.learned": "اتعلّمت من شاتك",
  "rules.none": "مفيش قواعد لسه. ضيف واحدة تحت أو قول للمساعد في الشات.",
  "rules.add": "إضافة قاعدة",
  "rules.placeholder": "مثال: جاوب بس على أسئلة إدارة القوى العاملة.",
  "voice.rt.title": "الصوت المباشر (full-duplex)",
  "voice.rt.hint":
    "اتكلم واقاطعه في أي لحظة زي ChatGPT Live. بيستخدم OpenAI Realtime بمفتاح OpenAI بتاعك أنت: OpenAI بتحاسبك بالدقيقة (وبيقفل لوحده بعد دقيقتين سكوت). المحادثة مش بتتحفظ في سجل الشات.",
  "voice.rt.use": "استخدم الصوت المباشر لما يبقى فيه مفتاح OpenAI",
  "voice.rt.ready": "لقيت مفتاح OpenAI — وضع الصوت هيستخدم الصوت المباشر.",
  "voice.rt.needKey":
    "مفيش مفتاح OpenAI لسه. ضيف provider من OpenAI بمفتاحك في Settings ← Models والصوت المباشر هيشتغل لوحده. لحد وقتها بيشتغل وضع الصوت المجاني.",
  "voice.rt.badge": "OpenAI Realtime · مدفوع",
  "voice.rt.connecting": "بيتصل…",
  "voice.rt.error": "مقدرتش أشغّل الصوت المباشر",
  "signin.title": "طرق تسجيل الدخول",
  "signin.hint":
    "خلّي الناس تسجّل بجوجل أو أبل أو مايكروسوفت (Outlook/Hotmail) أو GitHub أو GitLab أو Discord. اعمل تطبيق في كونسول المزوّد، والصق مفاتيحه هنا (بتتخزن مشفّرة ومبتتعرضش تاني) وشغّله. الأزرار بتظهر في شاشة الدخول لوحدها.",
  "signin.on": "شغّال — الزرار ظاهر في شاشة الدخول",
  "signin.off": "متظبط بس مقفول",
  "signin.notConfigured": "لسه مش متظبط",
  "signin.fromEnv": "المفاتيح جاية من Worker secrets",
  "signin.setup": "ظبط / عدّل المفاتيح",
  "signin.steps":
    "1) اعمل التطبيق والصق رابط الـ redirect ده. 2) انسخ الـ Client ID والـ secret هنا. 3) احفظ وشغّل.",
  "signin.console": "افتح كونسول المزوّد",
  "signin.redirect": "رابط الـ Redirect",
  "signin.copy": "نسخ",
  "signin.secretSaved": "محفوظ (سيبه فاضي عشان يفضل زي ما هو)",
  "features.title": "المزايا (مركز التحكم)",
  "features.hint":
    "شغّل أو اقفل ميزة كاملة لكل المستخدمين. الميزة المقفولة بتختفي والسيرفر بيرفضها. حسابك كـ owner بيفضل واصل لأدواته (ما عدا أدوات الـ Agent اللي تقفلها من هنا).",
  "interface.autoSearch": "البحث التلقائي",
  "interface.autoSearchHint":
    'في أسئلة الأخبار و"النهارده" و"آخر"، المساعد بيبحث على النت الأول (أخبار مجانية + Wikipedia، أو SearXNG بتاعك أو مفتاح بحث) ويجاوب من النتايج مع المصادر.',
  "interface.autoSkills": "مهارات الخبراء",
  "interface.autoSkillsHint":
    "بيطبّق المهارة المناسبة لطلبك تلقائي (تصميم مواقع، كود نضيف، معادلات إكسل، SQL، أمان، عربي/RTL، رسوم بيانية، حسابات WFM…).",
  "interface.imageGen": "مولّد الصور",
  "interface.imageGenHint":
    "المدمج (مجاني، أونلاين) أو سيرفرك أنت اللي بيدعم /images/generations (LocalAI أو Stable Diffusion API أو DALL·E…). ضروري للصور في وضع المحلي فقط.",
  "interface.imageGen.builtin": "المدمج (أونلاين)",
  "indep.title": "الاستقلال (البيت / بدون نت)",
  "indep.hint":
    "شوف إيه اللي لسه معتمد على النت أو على AI بتاع حد تاني، وامنعه. كل اللي تحت ينفع ينتقل بعدين لجهازك أنت: راجع docs/HOME-SERVER.md.",
  "indep.localOnly": "وضع المحلي فقط",
  "indep.localOnlyHint":
    "مفيش حاجة بتتبعت لـ AI أو API أو موقع خارجي: بس الموديلات اللي على شبكتك هي اللي بترد، والبحث بيستخدم SearXNG بتاعك بس، وتسجيل الدخول الاجتماعي والـ push والصوت السحابي بيترفضوا. لو مفيش موديل محلي الشات هيقولك.",
  "indep.tokens": "مفاتيح API (واجهة متوافقة مع OpenAI)",
  "indep.tokensHint":
    'خلّي Home Assistant أو أي سكربت أو تطبيق تاني يستخدم المساعد ده (نفس الموديلات ونفس التبديل التلقائي). استخدم الموديل "auto" أو "providerId::model".',
  "indep.tokenName": "اسم المفتاح",
  "indep.tokenCreate": "إنشاء مفتاح",
  "indep.tokenOnce": "انسخه دلوقتي - بيظهر مرة واحدة بس.",
  "indep.searx": "عنوان SearXNG (محرك بحثك الخاص)",
  "indep.searxHint":
    "محرك بحث بتشغّله بنفسك من غير حساب ولا مفتاح. بيتستخدم في البحث التلقائي، وهو البحث الوحيد المسموح في وضع المحلي.",
  "indep.status": "إيه معتمد على إيه (دلوقتي)",
  "indep.guide":
    "محلي = على جهازك أو متصفحك. خارجي = محتاج النت أو خدمة شركة. إزاي تنقل كل جزء للبيت: docs/HOME-SERVER.md.",
  "indep.item.llm": "موديلات اللغة",
  "indep.item.stt": "تحويل الصوت لنص",
  "indep.item.tts": "تحويل النص لصوت",
  "indep.item.image": "توليد الصور",
  "indep.item.search": "البحث على النت",
  "indep.item.signin": "تسجيل الدخول",
  "indep.item.push": "إشعارات الـ push",
  "indep.item.hosting": "مكان تشغيل التطبيق",
  "indep.state.local": "محلي",
  "indep.state.external": "خارجي",
  "indep.state.mixed": "مختلط",
  "indep.state.off": "مقفول",
  "artifact.close": "إغلاق اللوحة",
  "artifact.you": "أنت",
  "artifact.preview": "معاينة",
  "artifact.download": "تنزيل",
  "artifact.as": "تنزيل كـ",
  "artifact.asSource": "تنزيل الملف المصدر",
  "artifact.share": "مشاركة",
  "artifact.shareHint": "أنشئ رابط عام للقراءة فقط يفتحه أي حد (من غير تسجيل دخول).",
  "artifact.sharedHint": "أي حد معاه الرابط يقدر يشوف آخر نسخة.",
  "artifact.createLink": "إنشاء رابط",
  "artifact.unshare": "إيقاف المشاركة",
  "artifact.restore": "استعادة النسخة دي",
  "artifact.oldVersion": "نسخة أقدم",
  "artifact.saveVersion": "حفظ كنسخة جديدة",
  "artifact.type.html": "صفحة ويب",
  "artifact.type.svg": "صورة SVG",
  "artifact.type.markdown": "Markdown",
  "artifact.type.code": "كود",
  "artifact.type.mermaid": "رسم بياني",
  "artifact.type.document": "مستند",
  "artifact.type.sheet": "جدول بيانات",
  "artifact.type.slides": "عرض تقديمي",
  "shared.gone": "الرابط ده مبقاش متاح",
  "shared.goneHint": "ممكن صاحبه أوقف المشاركة.",
  "shared.footer": "تمت المشاركة عبر AI من QN Ventures",
  "settings.agents": "الوكلاء",
  "nav.projects": "المشاريع",
  "agents.pick": "اختيار الوكيل",
  "agents.mine": "وكلائي",
  "agents.intro":
    "الوكلاء متخصصون لكل واحد تعليماته وأدواته ومهاراته (ونموذجه لو حبيت). الوكيل الافتراضي (QN) بيوزّع الشغل على الباقيين بالتوازي.",
  "agents.new": "وكيل جديد",
  "agents.edit": "تعديل الوكيل",
  "agents.builtin": "مدمج",
  "agents.duplicate": "نسخ",
  "agents.icon": "الأيقونة",
  "agents.description": "وصف مختصر",
  "agents.instructions": "التعليمات",
  "agents.instructionsPh": "مين الوكيل ده، بيشتغل إزاي، وإيه اللي مينفعش يعمله أبدًا…",
  "agents.model": "النموذج",
  "agents.inheritModel": "استخدم نموذج المحادثة",
  "agents.tools": "الأدوات",
  "agents.allTools": "كل الأدوات",
  "agents.skills": "المهارات",
  "agent.using": "بيستخدم",
  "agent.brief": "المهمة",
  "agent.report": "التقرير",
  "projects.new": "مشروع جديد",
  "projects.newChat": "محادثة جديدة في المشروع",
  "projects.chats": "المحادثات",
  "projects.noChats": "لسه مفيش محادثات في المشروع ده.",
  "projects.instructionsHint": "بتتطبّق على كل محادثة في المشروع",
  "projects.knowledge": "المعرفة",
  "projects.knowledgeHint":
    "الملفات هنا متاحة لكل محادثات المشروع (بيتم استخراج النص واستخدامه كمرجع).",
  "projects.addFiles": "إضافة ملفات",
  "settings.memory": "الذاكرة",
  "settings.usage": "الاستهلاك والفوترة",
  "memory.controls": "الذاكرة",
  "memory.intro":
    "AI بيقدر يفتكر معلومات عنك عبر المحادثات. وإنت بتشوف وتعدّل وتمسح أي حاجة بيفتكرها.",
  "memory.enabled": "استخدام الذاكرة",
  "memory.enabledHint": "لو مقفولة، مفيش حاجة بتتسترجع أو بتتحفظ.",
  "memory.auto": "التعلّم تلقائيًا",
  "memory.autoHint":
    "بعد المحادثة بيستخلص معلومات دائمة من اللي إنت كتبته (مش من صفحات الويب ولا الملفات).",
  "memory.expire": "انسَ اللي اتعلّمته لوحدي بعد",
  "memory.expireHint":
    "بتنتهي بس الذكريات المتعلّمة تلقائياً من المحادثات، واللي كتبتها بنفسك مبتنتهيش أبداً. اللي بتنتهي ممكن ترجّعها خلال 7 أيام.",
  "memory.expireNever": "أبداً (الافتراضي)",
  "memory.expireDays": "{n} يوم من غير استخدام",
  "memory.forgetLearned": "انسَ كل اللي اتعلّمته من المحادثات",
  "memory.forgetLearnedHint":
    "بيمسح بس الذكريات اللي المساعد حفظها لوحده. تقدر ترجّعها خلال 7 أيام.",
  "memory.forgetLearnedConfirm":
    "تمسح كل اللي المساعد اتعلّمه من محادثاتك؟ ذكرياتك اللي كتبتها بتفضل.",
  "memory.learnedOnly": "المتعلّم من المحادثات بس",
  "memory.deleted": "اتمسح مؤخراً",
  "memory.deletedHint": "محفوظ 7 أيام عشان تتراجع، وبعدها بيتمسح نهائي.",
  "memory.restore": "رجّعه",
  "memory.purge": "امسحهم نهائي",
  "memory.purgeConfirm": "تمسح الذكريات دي نهائياً؟ مش هتقدر ترجّعها.",
  "learning.acceptedList": "الدروس المقبولة ({n})",
  "learning.reopen": "تراجع (يرجع معلّق)",
  "memory.add": "إضافة ذاكرة",
  "memory.placeholder": "مثال: بشتغل في إدارة القوى العاملة وبفضّل الإجابات المختصرة",
  "memory.category": "التصنيف",
  "memory.cat.preference": "تفضيل",
  "memory.cat.fact": "معلومة",
  "memory.cat.person": "شخص",
  "memory.cat.work": "شغل",
  "memory.cat.other": "أخرى",
  "memory.src.manual": "أضفتها إنت",
  "memory.src.auto": "اتعلّمت تلقائيًا",
  "memory.src.tool": "حفظها المساعد",
  "memory.saved": "اللي فاكره",
  "memory.search": "بحث في الذاكرة",
  "memory.allCats": "كل التصنيفات",
  "memory.export": "تصدير",
  "memory.import": "استيراد",
  "memory.badFile": "الملف ده مش تصدير ذاكرة صالح.",
  "memory.emptyTitle": "لسه مفيش حاجة محفوظة",
  "memory.emptyHint": "الذكريات بتظهر هنا وإنت بتتكلم، أو ضيف واحدة من فوق.",
  "memory.clear": "انسَ كل حاجة",
  "memory.clearConfirm": "مسح كل الذكريات؟ مينفعش التراجع.",
  "usage.range": "الفترة",
  "usage.lastDays": "آخر {n} يوم",
  "usage.cost": "التكلفة التقديرية",
  "usage.costHint": "من الأسعار اللي حطيتها لكل نموذج",
  "usage.calls": "استدعاءات النموذج",
  "usage.input": "توكن الإدخال",
  "usage.output": "توكن الإخراج",
  "usage.perDay": "التوكن يوميًا",
  "usage.none": "مفيش استهلاك في الفترة دي.",
  "usage.byModel": "حسب النموذج",
  "usage.byAgent": "حسب الوكيل",
  "usage.budget": "الميزانية",
  "usage.budgetHint":
    "حد أمان اختياري. لما صرف الشهر يوصله، الرسائل الجديدة بتتوقف لحد ما ترفعه أو تمسحه.",
  "usage.monthly": "الحد الشهري (دولار)",
  "usage.spentMonth": "المصروف الشهر ده: {v}",
  "usage.noLimit": "بدون حد",
  "palette.title": "لوحة الأوامر",
  "palette.placeholder": "ابحث في المحادثات والملفات والذاكرة… أو اكتب أمر",
  "palette.agentOn": "تشغيل وضع الوكيل",
  "palette.agentOff": "إيقاف وضع الوكيل",
  "palette.cycleTheme": "تبديل السمة (داكن / فاتح / النظام)",
  "settings.connectors": "الموصّلات",
  "settings.automations": "الأتمتة",
  "connectors.intro":
    "اربط أدوات خارجية عبر MCP (بروتوكول سياق النموذج). أدواتها بتبقى متاحة للوكلاء، وأي أداة بتغيّر بيانات بتطلب موافقتك افتراضيًا.",
  "connectors.add": "إضافة موصّل",
  "connectors.emptyTitle": "لسه مفيش موصّلات",
  "connectors.emptyHint":
    "GitHub وCloudflare وSupabase وNotion وSlack وLinear — أو أي MCP server بالرابط.",
  "connectors.status.connected": "متصل",
  "connectors.status.needs_auth": "محتاج تفويض",
  "connectors.status.error": "خطأ",
  "connectors.status.new": "لم يُفحص",
  "connectors.connect": "ربط",
  "connectors.connectContinue": "متابعة للتفويض",
  "connectors.refresh": "فحص وتحديث",
  "connectors.toolsCount": "{n} أداة",
  "connectors.noTools": "لسه ملقيناش أدوات. استخدم «فحص وتحديث».",
  "connectors.readOnly": "قراءة فقط",
  "connectors.deleteConfirm": "حذف «{name}» وبيانات اعتماده المحفوظة؟",
  "connectors.connected": "تم ربط الموصّل.",
  "connectors.oauthFailed": "فشل التفويض ({e}).",
  "connectors.dismiss": "إغلاق",
  "connectors.authType": "المصادقة",
  "connectors.token": "رمز الوصول",
  "connectors.none": "بدون",
  "connectors.url": "رابط MCP server",
  "auto.intro":
    "شغّل الوكلاء بجدول زمني أو لما حاجة تنادي webhook. التشغيل بيتم بدون وجودك: الأدوات اللي محتاجة موافقة بتوقف التشغيل وبتبعتلك إشعار.",
  "auto.schedules": "المهام المجدولة",
  "auto.newSchedule": "جدول جديد",
  "auto.noSchedules": "مفيش مهام مجدولة",
  "auto.noSchedulesHint": "مثال: كل يوم عمل الساعة 08:00: «لخّص مستوى الخدمة امبارح لكل طابور».",
  "auto.next": "التالي",
  "auto.last": "الأخير",
  "auto.open": "فتح",
  "auto.runNow": "شغّل دلوقتي",
  "auto.webhooks": "Webhooks",
  "auto.webhooksHint": "رابط سري بيشغّل الوكيل. محتوى الطلب بيتسلّم للوكيل كبيانات غير موثوقة.",
  "auto.newWebhook": "Webhook جديد",
  "auto.noWebhooks": "مفيش webhooks",
  "auto.hits": "{n} استدعاء",
  "auto.webhookReady": "تم إنشاء الـ webhook",
  "auto.webhookOnce": "انسخ الرابط ده دلوقتي — بيظهر مرة واحدة بس.",
  "auto.namePh": "ملخص الصبح",
  "auto.prompt": "المطلوب من الوكيل؟",
  "auto.promptPh": "لخّص مستوى الخدمة امبارح لكل طابور ونبّهني لأي حاجة تحت الهدف.",
  "auto.hookPrompt": "تعليمات كل استدعاء",
  "auto.hookPromptPh": "صنّف التنبيه الوارد واقترح الخطوات التالية.",
  "auto.frequency": "التكرار",
  "auto.freq.hourly": "كل ساعة",
  "auto.freq.daily": "كل يوم",
  "auto.freq.weekdays": "أيام العمل",
  "auto.freq.weekly": "كل أسبوع",
  "auto.freq.custom": "مخصص (cron)",
  "auto.day": "اليوم",
  "auto.at": "الساعة",
  "auto.atMinute": "عند الدقيقة",
  "auto.timezone": "المنطقة الزمنية",
  "auto.defaultAgent": "الوكيل الافتراضي (QN)",
  "auto.unattendedNote":
    "التشغيل التلقائي مينفعش يطلب موافقة: الأدوات المضبوطة على «اسأل» هتوقف التشغيل وتبعتلك إشعار.",
  "auto.create": "إنشاء",
  "notif.title": "الإشعارات",
  "notif.none": "مفيش حاجة لسه",
  "notif.markRead": "تعليم الكل كمقروء",
  "notif.clear": "مسح",
  "notif.enableDesktop": "تفعيل تنبيهات سطح المكتب",
  "models.useBinding": "استخدم Workers AI المدمج (من غير API token)",
  "health.healthy": "سليم",
  "health.degraded": "متدهور",
  "health.down": "واقع — بيتجاوزه",
  "health.unknown": "لم يُفحص",
  "auth.code": "رمز التحقق",
  "auth.codeHint": "رمز من 6 أرقام أو رمز استرداد",
  "auth.or": "أو",
  "auth.oauthError": "فشل تسجيل الدخول ({e}).",
  "twofa.title": "المصادقة الثنائية",
  "twofa.hint":
    "اطلب رمز من تطبيق المصادقة (Google Authenticator أو 1Password أو Authy…) بالإضافة لكلمة المرور.",
  "twofa.on": "مفعّلة — باقي {n} رمز استرداد",
  "twofa.off": "متوقفة",
  "twofa.enable": "تفعيل",
  "twofa.disable": "إيقاف",
  "twofa.setupTitle": "إعداد المصادقة الثنائية",
  "twofa.setupHint":
    "امسح رمز QR بتطبيق المصادقة، وبعدين اكتب الرمز المكوّن من 6 أرقام اللي بيظهرلك.",
  "twofa.confirm": "تحقق وفعّل",
  "twofa.codesTitle": "احفظ رموز الاسترداد",
  "twofa.codesHint": "كل رمز بيشتغل مرة واحدة لو ضاع جهازك. بتظهر دلوقتي بس.",
  "twofa.saved": "حفظتها",
  "offline.banner": "أنت غير متصل — بتشوف المحادثات المحفوظة. الرسايل الجديدة محتاجة اتصال.",
  "backup.title": "نسخ احتياطي على الـ Pi",
  "backup.hint":
    "الـ Pi بيسحب نسخة كاملة من بياناتك (المحادثات والذاكرة والمستندات والملفات والإعدادات) كل ليلة على الـ HDD وبيحتفظ بآخر 14 نسخة. مفاتيح المزوّدين بتفضل مشفّرة.",
  "backup.now": "نسخ احتياطي الآن",
  "backup.needsRunner": "اربط الـ Raspberry Pi الأول.",
  "evolve.title": "التحديث الذاتي التلقائي (تجريبي)",
  "evolve.off": "مقفول — التطبيق مقدرش يغيّر نفسه أبدًا. ده الوضع الافتراضي.",
  "evolve.warnTitle": "خطر: اقرا قبل ما تشغّله",
  "evolve.warn1":
    "تشغيله بيسمح للتطبيق يدمج (Merge) Pull Request في الريبو بتاعك من غير ما تقراه. والتغيير المدموج بيتنشر بواسطة workflow النشر عندك.",
  "evolve.warn2":
    "حتى مع كل الضمانات اللي تحت، التغييرات الآلية ممكن فيها أخطاء. إنت المسؤول عن اللي بيتدمج. سيبه مقفول لو التطبيق بيستخدمه ناس تانيين أو فيه بيانات متقدرش تخسرها.",
  "evolve.guardTitle": "ضمانات مبتتقفلش من الشاشة دي",
  "evolve.g1": "مبيعدّلش كود ولا ينشره بنفسه — بيدمج Pull Request موجود بس.",
  "evolve.g2": "لازم الـ PR يكون أخضر في CI على آخر commit بالظبط، وقابل للدمج، وهدفه main.",
  "evolve.g3":
    "الدمج التلقائي للوثائق والـ skills والترجمات والواجهة والاختبارات بس (حد أقصى {files} ملف و{lines} سطر، والكود لازم معاه اختبارات).",
  "evolve.g4":
    "الـ migrations والأسرار وتسجيل الدخول والأمان والـ dependencies وملفات النشر وكود الميزة دي نفسها لازم إنسان يراجعها دايمًا.",
  "evolve.g5": "بس لما التطبيق سليم (الاختبار الذاتي أخضر). ودمج ذاتي واحد كل 24 ساعة.",
  "evolve.g6":
    "بعد كل دمج بيشتغل مراقب 30 دقيقة؛ 3 فحوصات فاشلة ورا بعض بتجمّد التحديث الذاتي وتبلغك.",
  "evolve.g7":
    "التجميد معناه مفيش دمج لحد ما تكتب تأكيد. كل إجراء بيتسجل في سجل التدقيق. وإيقافه بيرجّع كل حاجة لوضع الاقتراح بس.",
  "evolve.enable": "شغّل التحديث الذاتي…",
  "evolve.disable": "إيقاف",
  "evolve.typeToEnable": "للتشغيل اكتب {phrase}",
  "evolve.mode": "الوضع",
  "evolve.propose": "اقتراح بس — بقيّم الـ PRs وإنت اللي بتدمج",
  "evolve.auto": "دمج تلقائي للـ PRs المعتمدة…",
  "evolve.typeToAuto": "للسماح بالدمج التلقائي اكتب {phrase}",
  "evolve.repo": "الريبو (owner/name)",
  "evolve.token":
    "توكن GitHub (كتابة بس، fine-grained: Pull requests + Contents write على الريبو ده بس)",
  "evolve.tokenSet": "التوكن محفوظ (مخفي)",
  "evolve.saveToken": "احفظ التوكن",
  "evolve.removeToken": "امسح التوكن",
  "evolve.pr": "رقم الـ Pull Request",
  "evolve.check": "افحص السياسة",
  "evolve.merge": "ادمج دلوقتي",
  "evolve.verdict.auto": "مؤهّل للدمج التلقائي",
  "evolve.verdict.human": "محتاج مراجعة بشرية",
  "evolve.verdict.blocked": "ممنوع بالسياسة",
  "evolve.frozen": "مجمّد: {reason}",
  "evolve.unfreezeType": "لفك التجميد اكتب {phrase}",
  "evolve.unfreeze": "فك التجميد",
  "evolve.freeze": "جمّد دلوقتي",
  "evolve.health": "الصحة {score}/100 ({level})",
  "evolve.degraded": "الميزات الاختيارية موقوفة مؤقتًا لحد ما التطبيق يتعافى.",
  "evolve.blockers": "ممنوع حاليًا بسبب: {list}",
  "evolve.confirm": "تأكيد",
  "signin.supabase.title": "جوجل عن طريق Supabase (من غير Google Cloud)",
  "signin.supabase.on": "شغال — زرار جوجل بيستخدم مشروع Supabase بتاعك",
  "signin.supabase.steps":
    "استخدم مشروع Supabase فيه جوجل متفعّل. في المشروع ده: Authentication ← URL Configuration ← Redirect URLs ← ضيف العنوان اللي تحت. بعدين الصق رابط المشروع والمفتاح العام (publishable).",
  "signin.supabase.key": "المفتاح العام (publishable / anon)",
  "data.training": "صدّر بيانات التدريب (إجابات 👍)",
  "data.trainingNone": "لسه مفيش إجابات عليها 👍. قيّم الإجابات الكويسة بالإبهام الأول.",
  "data.trainingDone": "اتصدّر {n} عينة تدريب (JSONL). خلّي الملف سري: فيه محادثاتك.",
  "nav.assistant": "المساعد",
  "assistant.tab.errands": "المهام",
  "errand.hint":
    "كل حاجة بتطلبها من المساعد بتبقى مهمة هنا: مستني إيه، الناس ردّت بإيه، وإيه اللي محتاج قرارك.",
  "errand.empty": "مفيش مهام مفتوحة",
  "errand.emptyHint": "اطلب من المساعد في الشات، مثلًا «اسأل محمد هو فاضي امتى الأسبوع ده».",
  "errand.showAll": "اعرض المهام المنتهية كمان",
  "errand.cancel": "الغي المهمة دي",
  "errand.timeline": "الخط الزمني",
  "errand.status.working": "شغال عليها",
  "errand.status.waiting": "مستني ردود",
  "errand.status.needs_you": "محتاجك",
  "errand.status.done": "خلصت",
  "errand.status.cancelled": "اتلغت",
  "errand.kind.created": "بدأت",
  "errand.kind.linked": "اتضاف",
  "errand.kind.said": "المساعد قال",
  "errand.kind.reply": "رد عليه",
  "errand.kind.needs_you": "محتاجك",
  "errand.kind.done": "خلصت",
  "errand.kind.failed": "مشكلة",
  "errand.kind.call": "مكالمة",
  "errand.kind.snooze": "بعدين",
  "errand.kind.cancelled": "اتلغت",
  "assistant.tab.threads": "المحادثات",
  "assistant.tab.contacts": "الأصدقاء",
  "assistant.tab.calendar": "التقويم",
  "assistant.tab.channels": "القنوات",
  "assistant.back": "رجوع",
  "assistant.note": "ملاحظة",
  "assistant.failed": "متبعتتش",
  "assistant.sender.assistant": "المساعد",
  "assistant.sender.owner": "إنت",
  "assistant.sender.contact": "هو",
  "assistant.sender.system": "النظام",
  "assistant.requestHint":
    "اكتب اللي عاوزه زي ما بتطلب من مساعد. هو اللي هيقوله لهم بكلامه هو، كمساعد ليك.",
  "assistant.verbatim": "ابعت كلامي بالظبط",
  "assistant.write": "اكتب رسالة…",
  "assistant.send": "ابعت",
  "assistant.close": "اقفل المحادثة",
  "assistant.language": "اللغة",
  "assistant.languageAuto": "اللغة: تلقائي",
  "assistant.deleteContactConfirm": "تمسح {name}؟ محادثاته مع المساعد هتتمسح كمان.",
  "assistant.cleanAge": "قديم قد إيه",
  "assistant.cleanAny": "أي عمر",
  "assistant.cleanDays": "أقدم من {n} يوم",
  "assistant.cleanThreads": "امسح المحادثات المنتهية",
  "assistant.cleanErrands": "امسح المهام المنتهية",
  "assistant.cleanAll": "امسح كل المحادثات",
  "assistant.cleanConfirm": "تمسح المنتهي المطابق؟ مش هتقدر ترجّعه.",
  "assistant.cleanAllConfirm":
    "تمسح كل المحادثات المطابقة حتى اللي لسه مستنية رد؟ مش هتقدر ترجّعها.",
  "assistant.cleaned": "اتمسح: {n}",
  "errand.delete": "امسح المهمة",
  "errand.deleteConfirm": "تمسح المهمة وتسلسلها؟ لو لسه شغالة هتتلغي الأول.",
  "assistant.nickname": "اللقب (مثلاً مراتي)",
  "assistant.gender": "النوع",
  "assistant.genderUnknown": "النوع: مش محدد",
  "assistant.genderF": "أنثى",
  "assistant.genderM": "ذكر",
  "assistant.deleteThread": "امسح المحادثة (عند الطرفين)",
  "assistant.deleteConfirm": "تمسح المحادثة دي عندك وعند التاني؟ مش هتقدر ترجّعها.",
  "assistant.clearMine": "امسح المحادثة من عندي",
  "assistant.clearConfirm": "تمسح المحادثة من عندك بس؟ التاني هيفضل عنده نسخته.",
  "assistant.inbox": "رسائل ليك من مساعدين تانيين",
  "assistant.noThreads": "مفيش محادثات لسه",
  "assistant.noThreadsHint":
    "قول في الشات: «كلم محمد وقوله ميتأخرش». المساعد هيتواصل معاه، ويرد على أسئلته في حدود طلبك، ويبلغك هنا.",
  "assistant.callState.ringing": "بيرن…",
  "assistant.callState.active": "على المكالمة",
  "assistant.callState.ended": "المكالمة انتهت",
  "assistant.callState.missed": "ما ردّش — بعتله رسالة بدل المكالمة",
  "assistant.callState.declined": "رفض المكالمة — بعتله رسالة بدلها",
  "assistant.voicePrefs": "صوت مساعدي وساعات الهدوء",
  "assistant.voiceGender": "صوت المساعد",
  "assistant.female": "ست",
  "assistant.male": "راجل",
  "assistant.quietFrom": "ماترنش عليا من",
  "assistant.quietTo": "لحد",
  "assistant.quietHint":
    "مساعدين الناس التانية مش هيرنوا عليك في الساعات دي (بتوقيتك)، هيسيبوا رسالة بدل الرنة. نفس الساعة في الخانتين = ما يمنعش.",
  "telegram.short": "تيليجرام (اختياري)",
  "telegram.title": "Telegram — كلّم مساعدك من موبايلك (مجاني)",
  "telegram.hint":
    "ابعت لبوتك الخاص رسالة زي ما تبعت لشخص، أو رسالة صوتية: بينفّذ الطلب، ويطلب موافقتك بأزرار قبل أي حاجة حساسة، ويبلّغك لما حد يرد، وممكن يبعتلك ملخص الصبح.",
  "telegram.step1": "افتح @BotFather في تيليجرام، ابعت /newbot وجاوب على السؤالين.",
  "telegram.step2": "انسخ التوكن اللي هيدهولك والصقه تحت.",
  "telegram.token": "توكن البوت",
  "telegram.connect": "اربط",
  "telegram.linked": "محادثتك مربوطة",
  "telegram.notLinked": "لسه مش مربوط",
  "telegram.getLink": "اربط تيليجرام بتاعي",
  "telegram.open": "افتح تيليجرام",
  "telegram.orSend": "أو ابعت لبوتك",
  "telegram.forward": "بلّغني هنا لما حد يرد أو شغل يخلص",
  "telegram.briefing": "ملخص الصبح الساعة",
  "telegram.off": "مقفول",
  "telegram.disconnect": "افصل",
  "assistant.status.waiting": "مستني الرد",
  "assistant.status.replied": "رد",
  "assistant.status.escalated": "محتاجك",
  "assistant.status.done": "خلص",
  "assistant.status.failed": "فشل",
  "assistant.status.closed": "مقفولة",
  "assistant.addContact": "ضيف صديق",
  "assistant.name": "الاسم",
  "assistant.phone": "التليفون",
  "assistant.noContacts": "مفيش أصدقاء لسه",
  "assistant.noContactsHint": "ضيف صديق برقم تليفون أو إيميل. لو عنده حساب هنا بيتربط تلقائي.",
  "assistant.noChannel": "مفيش وسيلة توصله لسه — اربط قناة أو ضيف رقم/إيميل",
  "assistant.shareFree": "قوله امتى أنا فاضي",
  "assistant.message": "ابعتله",
  "assistant.channel": "القناة",
  "assistant.autoChannel": "أنسب قناة",
  "assistant.addEvent": "ضيف ميعاد",
  "assistant.eventTitle": "العنوان",
  "assistant.start": "يبدأ",
  "assistant.end": "ينتهي",
  "assistant.busy": "مشغول (١٤ يوم جاية)",
  "assistant.free": "أوقات فاضية في ساعات شغلك",
  "assistant.nothing": "مفيش مواعيد",
  "assistant.feeds": "تقاويم مربوطة",
  "assistant.feedsHint":
    "الصق رابط تقويمك (بينتهي بـ .ics). أوتلوك: الإعدادات ← Calendar ← Shared calendars ← Publish a calendar ← اختار التقويم و«Can view all details» ← Publish ← انسخ لينك الـ ICS. جوجل: الإعدادات ← تقويمك ← Integrate calendar ← «Secret address in iCal format». قراءة بس، والرابط بيتخزن مشفّر.",
  "assistant.connect": "اربط",
  "assistant.shares": "شارك وقت فاضيّ/مشغوليّ مع حسابات تانية",
  "assistant.sharesHint":
    "بيشوفوا امتى إنت مشغول بس، من غير عناوين. ومساعدهم يقدر يستخدمه وهو بيرتب معاك.",
  "assistant.stopShare": "وقف المشاركة",
  "assistant.share": "شارك",
  "assistant.sharedWithMe": "شاركوا معاك: {names}",
  "assistant.channelsHint":
    "المساعد يقدر يبعت لناس جوه التطبيق ببلاش. للوصول لناس برّه التطبيق اربط حساباتك تحت (بتدفع لمزوّدك مباشرة، والمفاتيح بتتخزن مشفّرة ومبتظهرش تاني).",
  "assistant.calls": "مكالمات",
  "assistant.connected": "مربوط",
  "assistant.twilioHook":
    "في Twilio حط الـ webhooks دي عشان الردود وإجابات المكالمات توصل للمساعد: الرسائل «A message comes in» ← رابط SMS؛ والمكالمات بتتظبط تلقائي مع كل مكالمة.",
  "assistant.email": "الإيميل",
  "assistant.emailHint":
    "ردود الإيميلات بتروح صندوقك إنت. وعشان المساعد يقرأ الردود حوّلها لرابط الـ webhook (محتاج forwarder صغير؛ شوف docs/ASSISTANT.md).",
  "assistant.callTitle": "مكالمة مع المساعد",
  "assistant.answer": "رُد على المكالمة",
  "assistant.ch.app": "رسالة جوه التطبيق",
  "assistant.ch.appcall": "📞 مكالمة صوتية جوه التطبيق",
  "assistant.ch.email": "إيميل",
  "assistant.ch.sms": "SMS",
  "assistant.ch.whatsapp": "واتساب",
  "assistant.ch.call": "مكالمة تليفون حقيقية",
  "call.title": "مكالمة",
  "call.ringing": "بيرن…",
  "call.connecting": "بيتوصّل…",
  "call.ended": "المكالمة خلصت",
  "call.hangup": "أنهي",
  "call.assistantOf": "مساعد {name}",
  "call.assistantCalling": "مكالمة من المساعد",
  "popup.thinking": "المساعد بيرد…",
  "popup.quick.free": "أيوه فاضي",
  "popup.quick.later": "كمان شوية",
  "popup.quick.busy": "مش فاضي دلوقتي",
  "call.incoming": "مكالمة داخلة",
  "call.answer": "رُد",
  "call.decline": "ارفض",
  "call.declined": "اترفضت",
  "call.noAnswer": "محدش رد",
  "call.failed": "الاتصال فشل (ممكن فايروول قوي بيمنع الصوت المباشر).",
  "call.micDenied": "محتاج إذن الميكروفون عشان تتصل.",
  "call.callBtn": "اتصل",
};
